<template>
  <b-overlay
      :show="showOverlay"
      rounded="sm"
  >
    <b-card v-if="smartReportHeader" dir="rtl">
      <b-row>
        <b-col cols="12" class="mb-2">
          <b-badge size="lg" variant="success" v-if="generatedReportDate">
            <h3 class="text-white p-25">
              گزارشات در تاریخ {{ new Date(generatedReportDate).toLocaleTimeString('fa-IR',{
              minute:"2-digit",
              hour:"2-digit"
            }) }}
              -
              {{ new Date(generatedReportDate).toLocaleDateString('fa-IR') }}
            </h3>
          </b-badge>

          <!--          Object.keys(smartReportHeader)-->
        </b-col>
        <b-col v-for="(row,idx) in smartReportHeader" :key="idx" cols="12" xl="12"
               class=" py-2" :class="{'border-bottom':idx!==smartReportHeader.length -1}">
          <b-row>
            <b-col v-for="(item,itemIdx) in generatedRows(row)" :key="itemIdx" cols="12" xl="2">
              <template>
                <div class="d-flex align-items-center my-25 justify-content-between">
                  <span class="text-secondary " style="font-size: 13px">{{ getName(item.Key) }}</span>
                  <span style="font-size: 13px">{{
                      item.hasPrice ? Intl.NumberFormat('en-US').format(item.Value) : item.Value
                    }}
                                <small v-if="item.hasPrice">تومان</small>
                              </span>
                </div>
              </template>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-card>
    <b-row>
      <SmartReportCard @getNewProductId="setNewProductId" v-for="(item,idx) in sortedSmartReports" :key="item.order"
                       :coursesList="coursesList" :cardData="item">
      </SmartReportCard>
      <!--      <b-col v-for="(item,idx) in sortedSmartReports" cols="12" xl="3">-->
      <!--        <template v-if="item.order===10">-->
      <!--          <b-card style="min-height: 40rem">-->
      <!--            <div class="d-flex align-items-center justify-content-between">-->
      <!--              <strong style="font-size: 17px" class="text-primary   p-25">-->
      <!--                تعداد فالووینگ-->
      <!--              </strong>-->
      <!--            </div>-->
      <!--            <v-select-->
      <!--                class=""-->
      <!--                v-model="selectedProductId"-->
      <!--                label="title"-->
      <!--                :options="coursesList"-->
      <!--                :reduce="title => title.id"-->
      <!--            />-->
      <!--            <template>-->
      <!--              <div v-for="(item,idx) in productInstaPage"-->
      <!--                   class="d-flex align-items-center my-1 justify-content-between">-->
      <!--              <span dir="auto" class="text-secondary " style="font-size: 16px;overflow-wrap: anywhere">{{-->
      <!--                  item.title-->
      <!--                }}</span>-->
      <!--                <span dir="auto" style="font-size: 16px;overflow-wrap: anywhere">{{ item.count || item.duration }}-->
      <!--            </span>-->
      <!--              </div>-->
      <!--            </template>-->
      <!--          </b-card>-->
      <!--        </template>-->
      <!--      </b-col>-->
    </b-row>
  </b-overlay>
</template>

<script>
import {BRow, BCol, BCard, BOverlay, BBadge} from 'bootstrap-vue'

import {
  SmartDailyReport,
  SmartReportHeader,
  SmartMonthlyReport,
  SmartMostPageViewReport,
  SmartMostViewItemReport,
  SmartOnlineChatReport,
  SmartSaleDailyReport,
  SmartSaleMonthlyReport, GetTodayBirthDay, GetProductInstapageUser, ProductInstapageUserCourses,
} from "@/libs/Api/smartReport";
import Helper from "@/libs/Helper";
import vSelect from 'vue-select'

import SmartReportCard from "@/views/components/smartReportCard.vue";

export default {
  title: " پنل ادمین نهایی شو",
  components: {
    SmartReportCard,
    BRow,
    BCol,
    BCard,
    BOverlay,
    vSelect,
    BBadge
  },
  data() {
    return {
      showOverlay: false,
      newReports: [
        {
          "userCount": "تعداد کاربران",
          "order": 1
        },
        {
          "courseStudentCount": "تعداد کل دانشجویان دوره",
          "order": 2
        },
        {
          "blockUserCount": "کاربران بلاک شده",
          "order": 3
        },
        {
          "courseCount": "تعداد دوره ها",
          "order": 4
        },
        {
          "liveCount": "تعداد لایو های برگزار شده ",
          "order": 5
        },
        {
          "eductionPostCount": "تعداد پست های آموزشی",
          "order": 6
        },
        {
          "storyCount": "تعداد استوری های آپلود شده",
          "order": 7
        },
        {
          "blogCount": "تعداد بلاگ ها",
          "order": 8
        },
        {
          "blogCommentCount": "تعداد نظرات بلاگ ها",
          "order": 9
        },
        {
          "couponCount": "تعداد کوپن ها",
          "order": 10
        },
        {
          "useCouponCount": "تعداد کوپن های استفاده شده",
          "order": 11
        },
        {
          "unUseCouponCount": "تعداد کوپن های استفاده نشده",
          "order": 12
        },
        {
          "unRegisterUserCouponCount": "تعداد کوپن های بدون عضویت",
          "order": 13
        },
        {
          "totalSaleCount": "تعداد فروش کل",
          "order": 14
        },
        {
          "totalSalePrice": "مبلغ فروش کل",
          "order": 15
        },
        {
          "unSuccessfulSaleCount": "تعداد فروش ناموفق",
          "order": 16
        },
        {
          "unSuccessfulSalePrice": "مبلغ فروش ناموفق",
          "order": 17
        },
        {
          "successfulSaleCount": "تعداد فروش موفق",
          "order": 18
        },
        {
          "successfulSalePrice": "مبلغ فروش موفق",
          "order": 19
        },
        {
          "totalOrderCount": "تعداد سفارشات کل",
          "order": 20
        },
        {
          "totalOrderPrice": "مبلغ سفارشات کل",
          "order": 21
        },
        {
          "unSuccessfulOrderCount": "تعداد سفارشات ناموفق",
          "order": 22
        },
        {
          "unSuccessfulOrderPrice": "مبلغ سفارشات ناموفق",
          "order": 23
        },
        {
          "successfulOrderCount": "تعداد سفارشات موفق",
          "order": 24
        },
        {
          "successfulOrderPrice": "مبلغ سفارشات موفق",
          "order": 25
        },
        {
          "totalCourseVideoDuration": "زمان تمام دوره ها",
          "order": 26
        },
        {
          "averageVisitTimeOfTheCourse": "میانگین زمان بازدید دوره",
          "order": 27
        },

        {
          "unReadOnlineChatCount": "تعداد چت های خوانده نشده",
          "order": 28
        },
        {
          "todayUserBirthDayCount": "تعداد کاربران متولد امروز",
          "order": 29
        },
      ],
      smartReportHeaderKeys: {
        blockUserCount: 'کاربران بلاک شده',
        blogCommentCount: 'تعداد نظرات بلاگ ها',
        blogCount: 'تعداد بلاگ ها',
        couponCount: 'تعداد کوپن ها',
        courseCount: 'تعداد دوره ها',
        courseStudentCount: 'تعداد دانشجویان دوره ها',
        eductionPostCount: 'تعداد پست های آموزشی',
        liveCount: 'تعداد لایو های برگزار شده ',
        storyCount: 'تعداد استوری های آپلود شده',
        successfulOrderCount: 'تعداد سفارشات پرداخت شده',
        successfulOrderPrice: 'مبلغ سفارشات موفق',
        successfulSaleCount: 'تعداد فروش موفق',
        successfulSalePrice: 'مبلغ فروش موفق',
        totalOrderCount: 'تعداد سفارشات کل',
        totalOrderPrice: 'مبلغ سفارشات کل',
        totalSaleCount: 'تعداد فروش کل',
        totalSalePrice: 'مبلغ فروش کل',
        unReadOnlineChatCount: 'تعداد چت های خوانده نشده',
        unRegisterUserCouponCount: 'تعداد کوپن های بدون عضویت',
        unSuccessfulOrderCount: 'تعداد سفارشات ناموفق',
        unSuccessfulOrderPrice: 'مبلغ سفارشات ناموفق',
        unSuccessfulSaleCount: 'تعداد فروش ناموفق',
        unSuccessfulSalePrice: 'مبلغ فروش ناموفق',
        unUseCouponCount: 'تعداد کوپن های استفاده نشده',
        useCouponCount: 'تعداد کوپن های استفاده شده',
        userCount: 'تعداد کاربران',
        todayUserBirthDayCount: 'تعداد کاربران متولد امروز',
        averageVisitTimeOfTheCourse: 'میانگین زمان بازدید دوره',
        totalCourseVideoDuration: 'زمان تمام دوره ها'
      },
      smartMostViewItem: {
        1: 'پر بازدید ترین دوره در کل',
        2: 'پر بازدید ترین دوره 1 ماه گذشته',
        3: 'پر فروش ترین دوره',
        4: 'پر خرید ترین کاربران',
        5: 'پر نظرترین بلاگ ',
        6: 'نظرات دوره',
        7: 'بیشترین زمان دوره'
      },
      smartReportHeader: null,
      smartReports: [],
      productInstaPage: [],
      coursesList: [],
      selectedProductId: '',
      generatedReportDate: null

    }
  },
  computed: {
    Helper() {
      return Helper
    },
    sortedSmartReports() {
      return this.smartReports.sort((a, b) => a.order - b.order)
    }

  },
  mounted() {
    this.getSmartReportHeader()
    this.getSmartDailyReports() // آمار بازدید
    this.getSmartMonthlyReport()
    this.getSmartMostPageViewReport()
    this.getSmartMostViewItemReport(2, 4)
    this.getSmartMostViewItemReport(1, 5)
    this.getSmartMostViewItemReport(3, 6)
    this.getSmartSaleDailyReport()
    this.getSmartSaleMonthlyReport()
    this.getSmartMostViewItemReport(4, 9)

    this.getSmartMostViewItemReport(6, 11)
    this.getSmartMostViewItemReport(5, 12)
    this.getSmartMostViewItemReport(7, 13)
    this.getSmartOnlineChatReport()
    this.getTodayBirthDate()
    this.getCourseLists()
    this.getProductInstaPageUser()
  },

  methods: {
    setNewProductId(id) {
      this.selectedProductId = id
      this.getProductInstaPageUser()
    },
    generatedRows(row) {
      let keys = Object.keys(row)
      let singleRow = []
      keys.forEach((item) => {

        singleRow.push({
          Key: item,
          Value: row[item],
          hasPrice: item.toLowerCase().includes('price')
        })
      })
      return singleRow
    },
    getName(Key) {
      let result = [];
      if (Key !== 0) {
        result = this.newReports.find((item, idx) => {
          if (item[Key]) {
            return item
          }
        })
        return result[Key]
      }
      this.showOverlay = false

    },
    async getProductInstaPageUser() {
      let _this = this
      let getProductInstapageUser = new GetProductInstapageUser(_this)
      let data = {
        productId: _this.selectedProductId ? _this.selectedProductId : ''
      }
      getProductInstapageUser.setParams(data)
      await getProductInstapageUser.fetch((content) => {
        _this.productInstaPage = content
        let idx = _this.smartReports.findIndex(e => e.order === 10)
        if (idx > -1) {
          _this.$set(_this.smartReports, idx, {
            data: _this.productInstaPage,
            heading: 'تعداد فالوینگ',
            hasPrice: false,
            order: 10
          })
        } else {
          _this.smartReports.push({data: _this.productInstaPage, heading: 'تعداد فالوینگ', hasPrice: false, order: 10})
        }

      }, (err) => {
        console.log(err)
        _this.showOverlay = false


      })
      this.showOverlay = false

    },
    async getCourseLists() {
      let _this = this
      let productInstapageUserCourses = new ProductInstapageUserCourses(_this)
      await productInstapageUserCourses.fetch((content) => {
        _this.coursesList = content


      }, (err) => {
        console.log(err)
        _this.showOverlay = false

      })
    },
    async getTodayBirthDate() {
      let _this = this
      let getTodayBirthDay = new GetTodayBirthDay(_this)
      await getTodayBirthDay.fetch((content) => {
        _this.smartReports.push({data: content.data, heading: 'لیست کاربران متولد امروز', hasPrice: false, order: 15})
      }, (err) => {
        console.log(err)
        _this.showOverlay = false

      })
    },
    async getSmartReportHeader() {
      let _this = this
      let smartReportHeader = new SmartReportHeader(_this)
      _this.showOverlay = true

      await smartReportHeader.fetch((content) => {
        _this.smartReportHeader = content.data
        _this.generatedReportDate = JSON.parse(JSON.stringify(_this.smartReportHeader.createDate))
        delete _this.smartReportHeader.createDate
      }, (err) => {
        console.log(err)
        _this.showOverlay = false

      })

    },
    async getSmartDailyReports() {
      let _this = this
      let smartDailyReport = new SmartDailyReport(_this)
      await smartDailyReport.fetch((content) => {
        _this.smartReports.push({data: content.data, heading: 'آمار بازدید سایت روزانه', hasPrice: false, order: 1})
      }, (err) => {
        console.log(err)
        _this.showOverlay = false

      })
    },
    async getSmartMonthlyReport() {
      let _this = this
      let smartMonthlyReport = new SmartMonthlyReport(_this)
      await smartMonthlyReport.fetch((content) => {
        _this.smartReports.push({data: content.data, heading: 'آمار بازدید سایت', hasPrice: false, order: 2})
      }, (err) => {
        _this.showOverlay = false
        console.log(err)

      })
    },
    async getSmartMostPageViewReport() {
      let _this = this
      let smartMostPageViewReport = new SmartMostPageViewReport(_this)
      await smartMostPageViewReport.fetch((content) => {
        _this.smartReports.push({data: content, heading: 'پربازدید ترین صفحه', hasPrice: false, order: 3})
      }, (err) => {
        console.log(err)
        _this.showOverlay = false

      })
    },
    async getSmartMostViewItemReport(idx, orderIdx) {
      let _this = this
      let smartMostViewItemReport = new SmartMostViewItemReport(_this)
      smartMostViewItemReport.setParams({input: idx})
      await smartMostViewItemReport.fetch((content) => {
        _this.smartReports.push({
          data: content,
          heading: _this.smartMostViewItem[idx],
          hasPrice: _this.smartMostViewItem[idx].includes('فروش') || _this.smartMostViewItem[idx].includes('خرید'),
          order: orderIdx
        })
      }, (err) => {
        console.log(err)
        _this.showOverlay = false

      })
    },
    async getSmartOnlineChatReport() {
      let _this = this
      let smartOnlineChatReport = new SmartOnlineChatReport(_this)
      await smartOnlineChatReport.fetch((content) => {
        _this.smartReports.push({data: content.data, heading: 'چت های دریافت شده', hasPrice: false, order: 14})
      }, (err) => {
        console.log(err)
        _this.showOverlay = false

      })
    },
    async getSmartSaleDailyReport() {
      let _this = this
      let smartSaleDailyReport = new SmartSaleDailyReport(_this)
      await smartSaleDailyReport.fetch((content) => {
        _this.smartReports.push({data: content.data, heading: 'فروش', hasPrice: true, order: 7})
      }, (err) => {
        console.log(err)
        _this.showOverlay = false

      })
    },
    async getSmartSaleMonthlyReport() {
      let _this = this
      let smartSaleMonthlyReport = new SmartSaleMonthlyReport(_this)
      await smartSaleMonthlyReport.fetch((content) => {
        _this.smartReports.push({data: content.data, heading: ' فروش کل', hasPrice: true, order: 8})
      }, (err) => {
        console.log(err)
        _this.showOverlay = false

      })
    }

  },
}
</script>

<style lang="scss">

</style>
